import { render, staticRenderFns } from "./GamePc.vue?vue&type=template&id=273a8bad&scoped=true&"
import script from "./GamePc.vue?vue&type=script&lang=js&"
export * from "./GamePc.vue?vue&type=script&lang=js&"
import style0 from "./GamePc.vue?vue&type=style&index=0&id=273a8bad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a8bad",
  null
  
)

export default component.exports